var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileGuideline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 330,
    viewBox: "0 0 330 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_13655_168250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.629 339.514V296.876C324.629 274.259 315.66 252.569 299.694 236.577C283.728 220.584 259.615 209.485 239.494 201.028M90.5073 201.028C68.2721 210.014 46.2736 220.584 30.3076 236.577C14.3417 252.569 5.37207 274.259 5.37207 296.876V339.514",
    stroke: "white",
    strokeWidth: 10.5714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.529 187.285C204.938 187.285 236.886 134.957 236.886 76.8139C236.886 32.4139 204.938 5.45679 165.529 5.45679C126.12 5.45679 94.1719 31.3568 94.1719 76.8139C94.1719 134.428 126.12 187.285 165.529 187.285Z",
    stroke: "white",
    strokeWidth: 10.5714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13655_168250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 329.829,
    height: 329.829,
    fill: "white",
    transform: "translate(0.0859375 0.170898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGuideline);
export default __webpack_public_path__ + "static/media/profile-guideline.63408270e3e6736842d47c3621c8088b.svg";
export { ForwardRef as ReactComponent };